<template>
  <div v-if="item" class="form-group--border patient-card">
    <div class="patient-card__header">
      <h1 class="patient-card__title">
        {{ item.surname }} {{ item.name }} {{ item.patronimic }}
      </h1>

      <div class="patient-card__curator">
        <div><label class="control-label">Куратор</label></div>
        <div class="patient-card__curator-fio">{{ item.curatorName }}</div>
      </div>
      <AtomIcon
        name="cross-patient-card"
        class="patient-card__cross"
        @click="close"
      />
    </div>
    <hr class="patient-card__header-line" />
    <div class="scrollable-content">
      <div class="row">
        <div class="form-group col-3">
          <label class="control-label">Дата рождения</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          {{ $momentFormat(item.dateOfBirth, "DD.MM.YYYY") }}
        </div>
        <div class="form-group col-3">
          <label class="control-label">СНИЛС</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          {{ item.snils }}
        </div>
        <div class="form-group col-3">
          <label class="control-label">Адрес места жительства</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          {{ getAddress(1) }}
        </div>
        <div class="form-group col-3">
          <label class="control-label">Адрес постоянной регистрации</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          {{ getAddress(2) }}
        </div>
        <div class="form-group col-3">
          <label class="control-label">Диагноз</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          {{ item.diagRegisterName ?? "&mdash;" }}
        </div>
        <div class="form-group col-3">
          <label class="control-label">Посещаемые учебные заведения</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          <div v-for="el in item.journalPmpkEducations" :key="el.id">
            {{ el.organizationName }}
          </div>
        </div>
        <div
          class="form-group col-3"
          v-if="
            item.journalPmpkEmployments &&
            item.journalPmpkEmployments.length > 0
          "
        >
          <label class="control-label">Место работы</label>
        </div>
        <div class="form-group col-9 patient-card__item-data">
          <div v-for="el in item.journalPmpkEmployments" :key="el.id">
            {{ el.organizationName }}, {{ el.position }}
          </div>
        </div>
      </div>

      <h5>Услуги ИМАР</h5>
      <div class="table-inner">
        <table class="table-custom">
          <thead>
            <tr>
              <th>Услуга</th>
              <th>Объем</th>
              <th>Периодичность</th>
              <th>Срок предоставления</th>
              <th>Организация</th>
            </tr>
          </thead>
          <tbody v-if="item.journalImars && item.journalImars.length > 0">
            <tr v-for="el in item.journalImars" :key="el.id">
              <td>{{ el.serviceTypeName }}</td>
              <td>{{ el.count }}</td>
              <td>{{ el.period }}</td>
              <td>
                {{ $momentFormat(el.dateBegin, "DD.MM.YYYY") }} -
                {{ $momentFormat(el.dateEnd, "DD.MM.YYYY") }}
              </td>
              <td>{{ el.organizationName }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center">Ничего не найдено</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="patient-card__representatives"
        v-if="item.patientRepresentatives?.length > 0"
      >
        <h5 class="patient-card__representative-title">Представители</h5>
        <template v-for="el in item.patientRepresentatives" :key="el.id">
          <div class="row">
            <div class="form-group col-3">
              <label class="control-label">ФИО</label>
            </div>
            <div class="form-group col-9 patient-card__item-data">
              {{ el.representative.surname }} {{ el.representative.name }}
              {{ el.representative.patronimic }}
            </div>
            <div class="form-group col-3">
              <label class="control-label">Степень родства</label>
            </div>
            <div class="form-group col-9 patient-card__item-data">
              {{ el.relationType?.name }}
            </div>
            <div class="form-group col-3">
              <label class="control-label">Контактный телефон</label>
            </div>
            <div class="form-group col-9 patient-card__item-data">
              {{ el.representative.phone }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div>
      <div class="float-right d-flex align-items-center mt-4">
        <button-component type="button" class="btn" v-on:click="close">
          Закрыть
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/common/ui/ButtonComponent";
import AtomIcon from "@/common/ui/Icon.vue";
import Api from "../api/ras";
//import ComponentInput from "@/common/components/ComponentInput";
export default {
  name: "PatientShortCard",
  components: {
    ButtonComponent,
    AtomIcon,
  },
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      item: null,
    };
  },
  created() {
    this.loadCard();
  },
  methods: {
    loadCard() {
      Api.findShort(this.id).then((response) => {
        this.item = response.data;
      });
    },
    close() {
      this.$emit("close");
    },
    getAddress(typeId) {
      var res = "";
      var address = this.item.patientAddresses.find(
        (x) => x.addressTypeId == typeId
      );
      if (address != null) {
        res = address.state.name;
        if (address.postalCode) res += ", " + address.postalCode;
        if (address.district) res += ", " + address.district.name;
        res += ", " + address.city;
        res += ", " + address.street;
        res += ", " + address.house;
        if (address.housing) res += ", к. " + address.housing;
        if (address.building) res += ", стр. " + address.building;
        if (address.room) res += ", кв. " + address.room;
        if (address.floor) res += ", эт. " + address.floor;
      }

      return res;
    },
  },
  watch: {
    id: function (/*newValue, oldValue*/) {
      this.loadCard();
    },
  },
};
</script>

<style lang="scss" scoped>
.patient-card {
  &__header {
    display: flex;
    align-items: center;
    gap: 60px;
  }
  &__header-line {
    border: 1px solid #5a9cf1;
  }
  &__title {
    flex: 1;
    font-size: 24px;
    line-height: 28.8px;
  }
  &__curator {
    text-align: right;
  }
  &__curator-fio {
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 700;
  }
  &__cross {
    align-self: flex-start;
    cursor: pointer;
  }
  &__item-data {
    font-size: 16px;
    font-weight: 700;
  }
  &__representatives {
    padding-top: 32px;
  }
  &__representative-title {
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 600;
    margin-bottom: 22px;
  }
}
.scrollable-content {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 250px);
}
</style>
